import moment from 'moment'
import type { CalendarEvent, CalendarMapMarker, OptionsDocument } from 'paintscout'
import { getCrews } from '../../options'

export function mapEventsToMapMarkers({
  events,
  options,
  editingEventId
}: {
  events: CalendarEvent[]
  options: OptionsDocument
  editingEventId?: string
}): CalendarMapMarker[] {
  const markerData: CalendarMapMarker[] = []
  const estimatorEventNumbers: Record<string, number> = {}
  const crews = getCrews({ options, searchCrewValue: '' })

  const sortedEvents = events.sort((a, b) => {
    const startA = moment(a.start).unix()
    const startB = moment(b.start).unix()
    return startA - startB
  })

  // Track how many markers we've placed at each lat/lng so far
  const locationIndexes: Record<string, number> = {}

  for (const event of sortedEvents) {
    try {
      if (event.geocode) {
        const lat = event.geocode.lat
        const lng = event.geocode.lng

        const locKey = `${lat.toFixed(6)},${lng.toFixed(6)}`
        const estimatorId = event.estimator.id
        if (!estimatorEventNumbers[estimatorId]) {
          estimatorEventNumbers[estimatorId] = 1
        }

        // Get the index for this location (how many markers we've already placed here)
        const idx = locationIndexes[locKey] || 0
        locationIndexes[locKey] = idx + 1

        // No change to lat/lng
        const offsetLat = lat
        const offsetLng = lng

        const past = moment(event.end).isBefore(moment())

        const eventCrew = crews.find((crew) => crew._id === event.crew)

        let color
        if (editingEventId === event.id) {
          color = '#0766ee'
        } else if (eventCrew?.color) {
          color = eventCrew.color
        } else {
          color = event.estimator.color ?? '#888888'
        }

        markerData.push({
          lat: offsetLat,
          lng: offsetLng,
          color,
          eventNumber: estimatorEventNumbers[estimatorId],
          past,
          event,
          overlapIndex: idx // <-- add this
        })

        estimatorEventNumbers[estimatorId]++
      }
    } catch (error) {
      console.error(`Error geocoding address: ${event.address}`, error)
    }
  }

  return markerData
}
